<template>
  <script
    v-if="$route.name !== 'page-not-found' && $route.name !== 'error' && organizationStringified"
    v-html="organizationStringified"
    type="application/ld+json"
  ></script>
</template>
<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ReadyHook } from 'vue-asyncready'
import i18n from '@vue-storefront/i18n'

export default {
  name: 'OrganizationJson',
  mixins: [ReadyHook],
  data () {
    return {
      organizationJson: {}
    }
  },
  computed: {
    organizationStringified () {
      return JSON.stringify(this.organizationJson)
    }
  },
  created () {
    this.organizationJson = {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'ZENITH',
      url: `https://www.zenith-watches.com/${currentStoreView().storeCode || ''}`,
      logo: 'https://www.zenith-watches.com/assets/img/logo_black.svg',
      sameAs: [
        'https://www.facebook.com/ZenithWatches/',
        'https://www.instagram.com/zenithwatches/',
        'https://www.tiktok.com/@zenithwatches',
        'https://twitter.com/ZenithWatches',
        'https://www.lvmh.com/fr/nos-maisons/montres-joaillerie/zenith',
        'https://www.weibo.com/zenithchina',
        'https://www.youtube.com/user/zenithwatches',
        'https://lin.ee/XTWnnPA',
        'www.linkedin.com/company/official-zenith-branch-of-lvmh-swiss-manufactures-sa'
      ],
      foundingDate: '1865',
      description: i18n.t(
        'Official ZENITH website - Swiss luxury watches for men and women, combining noble watchmaking traditions with cutting‑edge innovations...'
      ),
      parentOrganization: 'LVMH',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'Switzerland',
        addressRegion: 'Le Locle',
        postalCode: '2400',
        streetAddress: '34 rue des Billodes'
      },
      founder: {
        '@type': 'Person',
        givenName: 'Georges',
        familyName: 'Favre Jacot',
        gender: 'Male',
        jobTitle: 'Founder'
      }
    }
  }
}
</script>
